<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-col lg="6" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5 text-light font-weight-bold"
          style="font-size: 3.5vw"
        >
          Let’s start playing <br />
          the game to better <br />
          your future
        </div>
      </b-col>

      <b-col lg="6" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-link style="position: absolute; top: 0; right: 0" to="dashboard">
          <img src="@/assets/images/logo/logo.png" alt="" class="logo" />
        </b-link>
        <b-col sm="8" md="6" lg="8" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold text-muted" title-tag="h2">
            Welcome to The Hustle Lab! 👋
          </b-card-title>
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login" autocomplete="off">
              <b-form-group
                label="Email"
                label-for="login-email"
                class="form-group light-label"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  class="inner-addon left-addon"
                  rules="required|email"
                >
                  <feather-icon icon="MailIcon" size="18" />
                  <b-form-input
                    id="login-email"
                    v-model="loginForm.email"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                    autocomplete="off"
                    autocorrect="off" 
                    autocapitalize="off"
                    class="light-label custom-form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <div class="d-flex justify-content-between light-label">
                  <label for="login-password" class="light-label">Password</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge inner-addon"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <feather-icon icon="LockIcon" size="18" />
                    <b-form-input
                      id="login-password"
                      v-model="loginForm.password"
                      :state="errors.length > 0 ? false : null"
                      class="custom-form-control password-addon light-label"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-link
                :to="{ name: 'auth-forgot-password' }"
                class="float-right mb-2"
              >
                <small class="text-light">Forgot Password?</small>
              </b-link>
              <b-button
                type="submit"
                class="rounded-pill shadow-none"
                style="background-color: #e84185 !important"
                :disabled="invalid || load"
                block
              >
                <center v-if="load">
                  <b-spinner variant="light" label="Spinning"></b-spinner>
                </center>
                <span v-else>
                  Login
                </span>
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>Don’t have an account? </span>
            <b-link :to="{ name: 'auth-register' }">
              <span style="color: #e84185">&nbsp;Sign up</span>
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BSpinner,

} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import { mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { getAuth } from '@/utils/auth';

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "admin",
      userEmail: "admin@demo.com",
      sideImg: require("@/assets/images/pages/login-v2.svg"),

      // validation rules
      required,
      email,
      loginForm: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      load: "users/load",
    }),
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          const payload = { query: this.loginForm };
          this.$store.dispatch("users/login", payload).then((res) => {
            if(this.authUser().user && this.authUser().user.type == 2){
              this.$store.commit('appConfig/UPDATE_SKIN', 'dark')
            }else {
              this.$store.commit('appConfig/UPDATE_SKIN', 'light')
            }
            if(res.user.school_status){
              localStorage.setItem("userData", JSON.stringify(res.user));
              localStorage.setItem(
                useJwt.jwtConfig.storageTokenKeyName,
                res.access_token
              );
              if(res.user.type == 2){
                this.$router.push({name: 'student_learning'});
              }else{
                this.$router.push({name: 'learning'});
              }
            }else{
              this.$router.push("inactive_school")
            }
          }).catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: `<h4>${error.response.data.message}</h4>`,
                  showConfirmButton: true,
                  confirmButtonColor: '#E84185',
                  allowOutsideClick: true
                });
              }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");
* {
  font-family: "Inter", sans-serif !important;
}
.logo {
  width: 200px;
}
@media (max-width: 992px) {
  .logo {
    width: 100px;
  }
  .auth-inner {
    display: flex !important;
    justify-content: center !important;
  }
}
.auth-wrapper {
  background: url("../../../assets/images/banner/dark_bakground.png") no-repeat;
  background-size: cover;
}
.auth-bg {
  background-color: #5a5a5a32 !important;
  color: #fff !important;
}

.custom-form-control {
  background-color: rgba(0, 0, 0, 0) !important;
  border: 1px solid #888 !important;
  height: 50px;
}
.inner-addon {
  position: relative;
}
.inner-addon .feather-mail,
.feather-lock {
  position: absolute;
  top: 16px;
  left: 10px;
  // pointer-events: none;
}
.left-addon input {
  padding-left: 40px;
  color: #fff !important;
}
.password-addon {
  padding-left: 40px !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  color: #fff !important;
}
</style>
